import { formatHeadquarters } from '@shared/constants/legal-info';
import { LegalLayout } from '../../../components/layout/LegalLayout';

export default function PolitiqueConfidentialite() {
  return (
    <LegalLayout
      title="Politique de confidentialité"
      url="https://solutionecofrance.fr/legal/politique-confidentialite"
      lastUpdated="01/05/2026"
    >
      <p>
        Solution Éco France accorde une importance particulière à la protection des données
        personnelles. La présente politique décrit les traitements mis en œuvre dans le cadre de
        l’utilisation du site <strong>solutionecofrance.fr</strong> et de nos services
        (diagnostic CEE, comparateur d’énergie, calculateur d’aides, formulaires de contact,
        espace partenaires artisans), conformément au Règlement (UE) 2016/679 du 27 avril 2016
        (RGPD) et à la loi n° 78-17 du 6 janvier 1978 modifiée relative à l’informatique, aux
        fichiers et aux libertés.
      </p>

      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement, au sens de l’article 4-7 du RGPD, est la société{' '}
        <strong>SOLUTION ÉCO FRANCE</strong> (SAS, SIREN 982 431 033), dont le siège social et
        les coordonnées figurent dans nos{' '}
        <a href="/legal/mentions-legales">mentions légales</a>.
      </p>
      <p>
        Notre <strong>délégué à la protection des données (DPO)</strong> peut être contacté à
        tout moment :
      </p>
      <ul>
        <li>
          <strong>Email :</strong>{' '}
          <a href="mailto:dpo@solutionecofrance.fr">dpo@solutionecofrance.fr</a>
        </li>
        <li>
          <strong>Voie postale :</strong> DPO — Solution Éco France, {formatHeadquarters()}.
        </li>
      </ul>

      <h2>2. Catégories de données collectées</h2>
      <p>Selon le service utilisé, les catégories de données suivantes peuvent être traitées :</p>
      <ul>
        <li>
          <strong>Données d’identification :</strong> nom, prénom, civilité, raison sociale,
          fonction.
        </li>
        <li>
          <strong>Coordonnées :</strong> adresse postale, adresse e-mail, numéro de téléphone.
        </li>
        <li>
          <strong>Données professionnelles :</strong> SIREN/SIRET, code NAF, segment tarifaire
          (C5/C4/C3/C2 ou T1/T2/T3/T4), surface bâtie, consommations énergétiques déclarées.
        </li>
        <li>
          <strong>Données techniques de l’habitation :</strong> type de chauffage, isolation,
          DPE, année de construction (uniquement pour le calculateur d’aides et le diagnostic).
        </li>
        <li>
          <strong>Données de connexion :</strong> adresse IP (anonymisée après 7 jours),
          horodatage, type de navigateur, pages consultées, source de trafic.
        </li>
        <li>
          <strong>Données de paiement :</strong> aucune donnée bancaire n’est collectée ou
          stockée par Solution Éco France ; les paiements éventuels sont opérés par un
          prestataire PCI-DSS certifié.
        </li>
      </ul>

      <h2>3. Finalités et bases légales</h2>
      <p>
        Conformément à l’article 6 du RGPD, chaque traitement repose sur une base légale
        explicite :
      </p>
      <ul>
        <li>
          <strong>Traitement de votre demande</strong> (diagnostic, comparateur, calculateur,
          devis) — exécution de mesures précontractuelles à votre demande (art. 6.1.b RGPD).
        </li>
        <li>
          <strong>Suivi commercial du dossier</strong> (rappel, qualification, envoi de
          propositions) — exécution du contrat ou intérêt légitime du responsable de traitement
          (art. 6.1.b et 6.1.f RGPD).
        </li>
        <li>
          <strong>Envoi d’e-mails transactionnels</strong> (confirmation, justificatifs,
          attestations CEE) — exécution du contrat (art. 6.1.b RGPD).
        </li>
        <li>
          <strong>Newsletter et communications marketing</strong> — consentement préalable et
          libre (art. 6.1.a RGPD), retirable à tout moment.
        </li>
        <li>
          <strong>Mesure d’audience anonymisée</strong> (PostHog EU, exemptée si configurée
          conformément aux recommandations CNIL) — intérêt légitime (art. 6.1.f RGPD).
        </li>
        <li>
          <strong>Gestion des obligations légales</strong> (facturation, comptabilité,
          conservation des pièces CEE pendant 9 ans en application du décret du 25 mars 2022) —
          obligation légale (art. 6.1.c RGPD).
        </li>
        <li>
          <strong>Sécurité du site et prévention de la fraude</strong> — intérêt légitime
          (art. 6.1.f RGPD).
        </li>
      </ul>

      <h2>4. Destinataires et sous-traitants</h2>
      <p>
        Vos données sont traitées par les équipes habilitées de Solution Éco France (commerce,
        bureau d’études, suivi de dossier CEE, comptabilité, support). Elles peuvent également
        être communiquées aux destinataires suivants, dans la stricte mesure nécessaire :
      </p>
      <ul>
        <li>
          <strong>Artisans RGE partenaires</strong> du réseau Solution Éco France, lorsque vous
          sollicitez un devis travaux (avec votre accord exprès).
        </li>
        <li>
          <strong>Fournisseurs d’énergie</strong> contactés dans le cadre du courtage (mandat de
          courtage signé).
        </li>
        <li>
          <strong>Obligés et délégataires CEE</strong> partenaires (TotalEnergies, EDF, Engie,
          Carrefour, Auchan, Leclerc…) pour la valorisation des dossiers CEE déposés en votre nom
          ou au nom de l’artisan.
        </li>
        <li>
          <strong>Administrations publiques</strong> sur réquisition légale (PNCEE, DGCCRF,
          autorité judiciaire, organismes sociaux).
        </li>
      </ul>
      <p>
        Pour la mise en œuvre technique du site, nous faisons appel aux sous-traitants suivants,
        encadrés par un contrat de sous-traitance conforme à l’article 28 du RGPD :
      </p>
      <ul>
        <li>
          <strong>Hébergement infrastructure :</strong> opérateur cloud UE (région{' '}
          <em>eu-west</em>).
        </li>
        <li>
          <strong>Cloudflare</strong> (USA, Standard Contractual Clauses + DPF) — CDN, WAF,
          stockage objet R2 (région EU).
        </li>
        <li>
          <strong>Resend</strong> (UE) — envoi d’e-mails transactionnels.
        </li>
        <li>
          <strong>PostHog</strong> (région UE) — analytics anonymisée et A/B tests.
        </li>
        <li>
          <strong>Sentry</strong> — supervision technique (logs anonymisés).
        </li>
        <li>
          <strong>Google reCAPTCHA</strong> (le cas échéant) — prévention du spam, déclenché
          uniquement après consentement.
        </li>
        <li>
          <strong>API publiques :</strong> INSEE Sirene v3 (données entreprises publiques), ADEME
          (référentiels travaux), EMMY (registre national des CEE).
        </li>
      </ul>

      <h2>5. Transferts de données hors Union européenne</h2>
      <p>
        Solution Éco France privilégie systématiquement des prestataires hébergés en Union
        européenne. Lorsque des transferts hors UE sont rendus nécessaires (notamment certains
        services de Cloudflare, Inc.), ils sont strictement encadrés par :
      </p>
      <ul>
        <li>
          les <strong>clauses contractuelles types (CCT)</strong> adoptées par la Commission
          européenne le 4 juin 2021 ;
        </li>
        <li>
          la certification au <strong>Data Privacy Framework (DPF) UE-USA</strong> lorsqu’elle
          est applicable ;
        </li>
        <li>
          des mesures techniques complémentaires (chiffrement en transit TLS 1.3, restrictions
          d’accès, journalisation).
        </li>
      </ul>

      <h2>6. Durées de conservation</h2>
      <ul>
        <li>
          <strong>Prospects (sans suite commerciale) :</strong> 3 ans à compter du dernier
          contact actif (recommandation CNIL).
        </li>
        <li>
          <strong>Clients :</strong> durée de la relation contractuelle + 5 ans à compter de la
          fin du contrat (preuve commerciale, art. L. 110-4 du Code de commerce).
        </li>
        <li>
          <strong>Pièces comptables :</strong> 10 ans (art. L. 123-22 du Code de commerce).
        </li>
        <li>
          <strong>Pièces de dossier CEE :</strong> 9 ans à compter de la fin de l’opération
          (décret n° 2022-449 du 25 mars 2022).
        </li>
        <li>
          <strong>Logs techniques et de sécurité :</strong> 12 mois maximum (recommandation CNIL
          / ANSSI).
        </li>
        <li>
          <strong>Cookies de mesure d’audience :</strong> 13 mois maximum, données associées 25
          mois.
        </li>
        <li>
          <strong>Consentements (preuve) :</strong> 5 ans à compter du retrait ou de la
          collecte.
        </li>
      </ul>

      <h2>7. Vos droits</h2>
      <p>
        Conformément aux articles 12 à 23 du RGPD, vous disposez des droits suivants sur vos
        données :
      </p>
      <ul>
        <li>
          <strong>Droit d’accès</strong> (art. 15) — obtenir une copie de vos données.
        </li>
        <li>
          <strong>Droit de rectification</strong> (art. 16) — corriger des données inexactes ou
          incomplètes.
        </li>
        <li>
          <strong>Droit à l’effacement</strong> (art. 17) — sous réserve des obligations légales
          de conservation.
        </li>
        <li>
          <strong>Droit à la limitation du traitement</strong> (art. 18).
        </li>
        <li>
          <strong>Droit d’opposition</strong> (art. 21) — notamment au profilage marketing.
        </li>
        <li>
          <strong>Droit à la portabilité</strong> (art. 20) — récupération de vos données dans
          un format structuré (JSON / CSV).
        </li>
        <li>
          <strong>Droit de retirer votre consentement</strong> à tout moment, sans que ce retrait
          n’affecte la licéité des traitements antérieurs.
        </li>
        <li>
          <strong>Directives post-mortem</strong> (art. 85 LIL) — vous pouvez nous communiquer
          des directives sur le sort de vos données après votre décès.
        </li>
      </ul>
      <p>
        Pour exercer ces droits, contactez notre DPO à{' '}
        <a href="mailto:dpo@solutionecofrance.fr">dpo@solutionecofrance.fr</a>. Une copie de
        votre pièce d’identité pourra vous être demandée en cas de doute raisonnable. Réponse
        sous un délai d’un mois (prolongeable de deux mois pour les demandes complexes,
        art. 12.3 RGPD).
      </p>

      <h2>8. Réclamation auprès de la CNIL</h2>
      <p>
        Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous
        pouvez introduire une réclamation auprès de la <strong>Commission Nationale de
        l’Informatique et des Libertés</strong> :
      </p>
      <ul>
        <li>3 place de Fontenoy — TSA 80715 — 75334 PARIS Cedex 07</li>
        <li>
          Téléphone : 01 53 73 22 22 — Site :{' '}
          <a href="https://www.cnil.fr" rel="noopener noreferrer" target="_blank">cnil.fr</a>
        </li>
      </ul>

      <h2>9. Sécurité des données</h2>
      <p>
        Solution Éco France met en œuvre les mesures techniques et organisationnelles
        appropriées pour garantir un niveau de sécurité adapté au risque (art. 32 RGPD) :
      </p>
      <ul>
        <li>chiffrement des communications en transit (TLS 1.3) ;</li>
        <li>chiffrement au repos des bases de données et du stockage objet ;</li>
        <li>politique de mots de passe robustes + authentification forte (MFA) sur les accès
          d’administration ;</li>
        <li>cloisonnement des environnements (production / staging / dev) ;</li>
        <li>journalisation et supervision (Sentry, alertes intrusion) ;</li>
        <li>plans de sauvegarde quotidiens, restauration testée trimestriellement ;</li>
        <li>sensibilisation continue des collaborateurs au RGPD et à la sécurité ;</li>
        <li>analyse d’impact (AIPD) réalisée pour les traitements à risque élevé.</li>
      </ul>

      <h2>10. Cookies et traceurs</h2>
      <p>
        L’utilisation des cookies et autres traceurs est encadrée par notre{' '}
        <a href="/legal/cookies">politique cookies</a> dédiée, conforme aux lignes directrices et
        à la recommandation de la CNIL du 17 septembre 2020 (mises à jour 2024).
      </p>

      <h2>11. Modification de la politique</h2>
      <p>
        Nous nous réservons le droit de modifier la présente politique à tout moment afin de
        l’adapter aux évolutions légales, réglementaires, jurisprudentielles ou techniques. La
        date de dernière mise à jour figure en tête de page. Pour les modifications
        substantielles, vous serez informé par tout moyen approprié (bandeau, e-mail).
      </p>
    </LegalLayout>
  );
}
